import type { RefObject } from "react";
import toast from "react-hot-toast";

export const ORDER_AHEAD_HOST = "vendor-manager.roninpos.com";

// Public ordering URL for a single order-ahead menu, keyed by its url_guid slug.
export const menuOrderUrl = (slug: string) =>
  `https://${ORDER_AHEAD_HOST}/order/${slug}`;

// Rasterize the rendered QR <svg> inside containerRef to a PNG and trigger a download.
// Scales the 200px on-screen QR up to 1024px so the saved image is crisp enough for print.
export const downloadQrPng = (
  containerRef: RefObject<HTMLDivElement>,
  fileName: string
) => {
  const svg = containerRef.current?.querySelector("svg");
  if (!svg) {
    toast.error("Couldn't read the QR code to download.");
    return;
  }
  const size = 1024;
  const svgData = new XMLSerializer().serializeToString(svg);
  const svgBlob = new Blob([svgData], {
    type: "image/svg+xml;charset=utf-8",
  });
  const url = URL.createObjectURL(svgBlob);
  const img = new Image();
  img.onload = () => {
    const canvas = document.createElement("canvas");
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext("2d");
    if (!ctx) {
      URL.revokeObjectURL(url);
      toast.error("Couldn't render the QR code for download.");
      return;
    }
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, size, size);
    ctx.drawImage(img, 0, 0, size, size);
    URL.revokeObjectURL(url);
    const link = document.createElement("a");
    link.download = fileName;
    link.href = canvas.toDataURL("image/png");
    link.click();
  };
  img.onerror = () => {
    URL.revokeObjectURL(url);
    toast.error("Couldn't render the QR code for download.");
  };
  img.src = url;
};
